export const sortByColumnFlow = <T>(unsortedImages: T[], cols: number): T[][] =>
  [...new Array(cols)].map((_, outerPos) =>
    unsortedImages.filter((_, innerPos) => innerPos % cols === outerPos)
  )

export default sortByColumnFlow
